export const CLIENT_PREFIX = 'client';

export const CLIENT_OUTDATED = 'client/CLIENT_OUTDATED';
export const REQUIRE_INTERACTIVE_RELOAD = 'client/REQUIRE_INTERACTIVE_RELOAD';
